import { render, staticRenderFns } from "./GetHelpForPDF.vue?vue&type=template&id=0b86ddec"
import script from "./GetHelpForPDF.vue?vue&type=script&lang=ts"
export * from "./GetHelpForPDF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports